import React from "react";
import { Dropdown } from "react-bootstrap";
import { ellipseIcon, floderMinusIcon, folderIcon, removeBookmarkIcon } from "../../constants/icons";

function SnackbarDropdown({ removeBookClick }) {
    return (
        <Dropdown className="common-dropdown snackbar-dropdown">
            <Dropdown.Toggle id="dropdown-user">
                {ellipseIcon}
            </Dropdown.Toggle>

            <Dropdown.Menu align="end">
                <Dropdown.Item href="#edit-profile">
                    {folderIcon} <span title="Move to folder">Move to folder</span>
                </Dropdown.Item>
                <Dropdown.Item href="#settings">
                    {floderMinusIcon} <span title="Remove from folder">Remove from folder</span>
                </Dropdown.Item>
                <Dropdown.Item href="#logout" onClick={removeBookClick}>
                    {removeBookmarkIcon} <span title="Remove bookmark">Remove bookmark</span>
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default SnackbarDropdown;
